<template>
  <UIButtonCount
    :leading
    :label
    :count
    :variant
    v-bind="$attrs"
    fill="light"
    data-refid="filter-button"
    class="ui-filter__toggle-button"
  />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { I18nTranslate } from '@types'

import { UIButtonCount } from '@ui/buttons'
import { FunnelIcon as leading } from '@heroicons/vue/24/outline'

type Props = {
  count?: number
  unlabeled?: boolean
}

const { count, unlabeled } = defineProps<Props>()

const t = inject<I18nTranslate>('t', (data: string) => data)

const label = computed(() => (count || unlabeled ? undefined : t('Filter')))
const variant = computed(() => (count ? 'secondary' : 'gray'))
</script>

<style>
.toggle-button {
  @apply h-full;
}
.filter__panel {
  @apply flex justify-between;
  @apply mb-2;

  h3 {
    @apply text-base sm:text-sm;
    @apply text-gray-500;
  }

  button {
    @apply px-2!;
  }
}
.filter__list {
  @apply space-y-2 mb-3;
}
.filter__add {
  @apply flex items-center justify-between;
}
</style>
